import { createElement, FunctionComponent, ReactNode, useState } from 'react';
import { PortalModal } from '../PortalModal';
import { ModalContext } from './ModalContext';
import { ModalOptions } from './types';

interface ModalProviderProps {
  children: ReactNode;
}

interface Modal {
  component: FunctionComponent<any>;
  props?: any;
  options: ModalOptions;
}

export const ModalProvider = ({ children }: ModalProviderProps) => {
  const [modalStack, setModalStack] = useState<Modal[]>([]);

  const push = (component: FunctionComponent<any>, props?: any, options: ModalOptions = {}) => {
    setModalStack([...modalStack, { component, props, options }]);
  };

  const pop = (status = null) => {
    setModalStack(
      modalStack.filter((modal, index) => {
        if (index === modalStack.length - 1) {
          if (typeof modal.options.onClose === 'function') {
            modal.options.onClose(status);
          }
          return false;
        }
        return true;
      }),
    );
  };

  const modalPortal = typeof document !== 'undefined' && document.getElementById('portal');

  return (
    <ModalContext.Provider value={{ push, pop }}>
      {children}
      {modalPortal &&
        modalStack.map((modal, idx) => (
          <PortalModal
            key={idx}
            isOpen
            setIsOpen={val => !val && pop()}
            noBackdrop={modal.options.noBackdrop}
            title={modal.options.title}
            stretchHeight={modal.options.stretchHeight}
          >
            {createElement(modal.component, {
              ...modal.props,
              pop,
            })}
          </PortalModal>
        ))}
    </ModalContext.Provider>
  );
};
